import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { EncryptService } from './encrypt.service';

@Injectable({
  providedIn: 'root'
})
export class LambdaServicesService {
  LAMBDA_URL = environment.LAMBDA_URL;
  constructor(
    private http: HttpClient,
    private encryptService: EncryptService,
  ) { }

  async secrets() {
    let url = this.LAMBDA_URL + '/secret/genesys';
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let params = {};

    try {
      let data: any = await this.http.post(url, params, httpOptions).toPromise();
      this.encryptService.setItem('credentials', JSON.stringify(data.credentials));
      return data.credentials;
    }
    catch (error) {
      throw error;
    }
  }

  async postDataClient(id_contacto) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/post_data_client';
    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    //console.log(url);
    let params = {
      id_contacto: id_contacto
    };

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log('Data cliente lambda');
      //console.log(data);
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async getOptionCampaign(id_campana, id_queue) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/get_option_campaign';

    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    //console.log(url);
    let params = {
      id_campana: id_campana,
      id_queue: id_queue
    };

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async getRecall(id_gestion) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/get_recall';
    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };

    let params = {
      id_gestion
    };

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      // this.errors.requestError(error)
      throw error;
    }
  }

  async postCallback(id_interaccion, mensaje, con_id) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/post_callback';

    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    //console.log(url);
    let params = {
      interaction: id_interaccion,
      meta: mensaje,
      con_id: con_id
    };
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data, 'postCallback');
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-postCallback');
      throw error;
    }
  }

  async postListCallback(user_id, skill_id) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));

    let url = credentials.URL_SERVICIOS_LAMBDA + '/post_list_callback';
    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    //console.log(url);
    let params = {
      // fecha: fecha,
      user_id: user_id,
      //skill_id: skill_id
    };
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data, 'postListCallback');
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-postListCallback');
      throw error;
    }
  }

  async getCallback(con_id) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/get_callback';
    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    //console.log(url);
    let params = {
      con_id: con_id,
    };
    // //console.log(params,'params-getCallback');

    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      console.log(data,'getCallback');
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-getCallback');
      throw error;
    }
  }

  async handleEnvioTipificaciones(params) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/res_json_gestiones';
    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-handleEnvioTipificaciones');
      throw error;
    }
  }

  async postListSales(user_id) {
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/post_list_sales';

    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    let params = {
      user_id: user_id,
    };
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      //console.log(data, 'postListSales');
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-postListSales');
      throw error;
    }
  }

  async updateKillCallback(conversationId: string) {
    console.log('updateKillCallback - conversationId:', conversationId);
    
    let credentials = JSON.parse(this.encryptService.getItem('credentials'));
    let url = credentials.URL_SERVICIOS_LAMBDA + '/callback/update';

    let httpOptions = {
      headers: new HttpHeaders({
        'authorizationToken': credentials.TOKEN_LAMBDA,
        'Content-Type': 'application/json'
      })
    };
    
    let params = {
      conversationId: conversationId
    };
    
    console.log('updateKillCallback - params:', params);
    console.log('updateKillCallback - url:', url);
    
    try {
      let data = await this.http.post(url, params, httpOptions).toPromise();
      console.log(data, 'updateKillCallback-response');
      return data;
    }
    catch (error) {
      console.log(error, 'ERROR-updateKillCallback');
      throw error;
    }
  }
}
